import { render } from "./SignupForm.vue?vue&type=template&id=537a1734"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marti\\Documents\\dev\\JavaScript\\live-chat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__